import { render, staticRenderFns } from "./SubportionTree.vue?vue&type=template&id=e5a9478a&"
import script from "./SubportionTree.vue?vue&type=script&lang=js&"
export * from "./SubportionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports